/**
 * Sentinel `localId` for files shown on an issue
 * via linked documentation. They are not stored in the service worker documents IndexedDB
 * table — URLs come from linked-documentation metadata or signed-request preview.
 */
export const LINKED_DOCUMENTATION_SW_LOCAL_ID = -1;

export function isLinkedDocumentationSwLocalId(localId: number): boolean {
  return localId === LINKED_DOCUMENTATION_SW_LOCAL_ID;
}
